import { Modal } from 'components/modal'
import { useAppSelector } from 'hooks/use-app-selector'
import useToggle from 'hooks/use-toggle'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import {
  selectAiSubscriptionLoading,
  selectIsAiSubscriptionActiveAndNotAdFreeOnly,
} from 'store/slices/subscription/subscription'
import { Button } from 'ui-kit/button'

import { AskAiModal } from './ask-ai-modal'

const ASK_AI_HIDDEN_KEY = 'ask-ai-button-hidden-from-pg'

export const AskAi = () => {
  const { isOpen, handleClose, handleOpen } = useToggle()
  const [isHidden, setIsHidden] = useState(false)
  const router = useRouter()
  const aiSubscriptionLoading = useAppSelector(selectAiSubscriptionLoading)
  const isAiSubscriber = useAppSelector(selectIsAiSubscriptionActiveAndNotAdFreeOnly)

  // Check localStorage on component mount
  useEffect(() => {
    const hiddenState = localStorage.getItem(ASK_AI_HIDDEN_KEY)
    if (hiddenState === 'true' && !isAiSubscriber) {
      setIsHidden(true)
    }
  }, [isAiSubscriber])

  const handleAction = () => {
    switch (true) {
      case aiSubscriptionLoading:
        return
      case !isAiSubscriber:
        router.push('/typing-mentor-coach')
        return
      default:
        handleOpen()
    }
  }

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation()
    localStorage.setItem(ASK_AI_HIDDEN_KEY, 'true')
    setIsHidden(true)
  }

  // Don't render if hidden
  if (isHidden) {
    return null
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <Button style={{ paddingLeft: '1.125rem' }} onClick={handleAction} disabled={aiSubscriptionLoading}>
        🤖 Ask AI
      </Button>

      {/* Show close icon only for non-subscribers */}
      {!isAiSubscriber && !aiSubscriptionLoading && (
        <button
          onClick={handleRemove}
          style={{
            position: 'absolute',
            top: '-6px',
            right: '-6px',
            width: '16px',
            height: '16px',
            border: 'none',
            backgroundColor: '#666',
            color: 'white',
            cursor: 'pointer',
            fontSize: '10px',
            lineHeight: '1',
            borderRadius: '2px',
          }}
          title="Remove Ask AI button"
        >
          X
        </button>
      )}

      <Modal fluid isOpen={isOpen} onClose={() => handleClose()} showCloseIcon>
        <AskAiModal handleClose={handleClose} />
      </Modal>
    </div>
  )
}
